export default __webpack_public_path__ + "media/images/favicon-2393cdeb4148eed115f6f683a9fb876e.ico";